export default __webpack_public_path__ + "static/1-7d7c6f9ab0dba001a810ca08290713c5.png";